import { render, staticRenderFns } from "./LootWeaponsProperties.vue?vue&type=template&id=e565b21c&lang=pug&"
import script from "./LootWeaponsProperties.vue?vue&type=script&lang=ts&"
export * from "./LootWeaponsProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports